const HERO_IMAGE_SETTINGS = {
  imageFileName: 'getLoan_background',
  imagePosition: '70%',
  imageTitle: 'images.home.hero.title.pl',
  imageAlt: 'images.home.hero.alt.pl',
};

export const useHeroImage = () => HERO_IMAGE_SETTINGS;

export default useHeroImage;
